import React from 'react';

const FileUpload = ({ size = 20, color="#4E596C" }: { size?: number ; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 13.5L12 11M12 11L9.5 13.5M12 11V17M20.9686 7H3.03143M21 7.49242V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V7.49242C3 7.16537 3.04011 6.83956 3.11943 6.52228L3.62127 4.51493C3.72945 4.08222 3.97917 3.69808 4.33073 3.42359C4.68229 3.1491 5.11552 3 5.56155 3H18.4385C18.8845 3 19.3177 3.1491 19.6693 3.42359C20.0208 3.69808 20.2706 4.08222 20.3787 4.51493L20.8806 6.52228C20.9599 6.83956 21 7.16537 21 7.49242Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FileUpload;
